export default {
  CHANGE: "CHANGE",
  TOGGLE_SIDEBAR: "TOGGLE_SIDEBAR",
  LOGISTICA_PETSHOP: 'petshop',
  LOGISTICA_COLECTA: 'colecta',
  LOGISTICA_ON_DEMAND: 'on demand',
  LOGISTICA_FLEX: 'flex',
  COMPRA_TARJETA_FALTA_PAGAR: 4
};
